import { ListerActionTypes } from '../../../enums/ActionEnums';
export const listerActions = {
    createInitializeAction: () => ({
        type: ListerActionTypes.LISTER_INIT,
    }),
    updateProducts: (items) => ({
        type: ListerActionTypes.UPDATE_PRODUCTS,
        payload: items,
    }),
    updateProductsAndTotalPages: (items, totalPages) => ({
        type: ListerActionTypes.UPDATE_PRODUCTS_AND_TOTAL_PAGES,
        payload: { products: items, totalPages },
    }),
    updateProductsAndTotalPagesAndItemCount: (products, totalPages, itemCount) => ({
        type: ListerActionTypes.UPDATE_PRODUCTS_AND_TOTAL_PAGES_AND_ITEM_COUNT,
        payload: { products, totalPages, itemCount },
    }),
    updateExistingFilters: (filters) => ({
        type: ListerActionTypes.UPDATE_EXISTING_FILTERS,
        payload: filters,
    }),
    showPlaceholderTiles: () => ({
        type: ListerActionTypes.SHOW_PLACEHOLDER_TILES,
    }),
    updateInStoreFilter: (store) => ({
        type: ListerActionTypes.UPDATE_IN_STORE_FILTER,
        payload: store,
    }),
    getListerProducts: () => ({
        type: ListerActionTypes.GET_LISTER_PRODUCTS,
    }),
    setListerStateAction: (searchObject) => ({
        type: ListerActionTypes.SET_LISTER_STATE,
        payload: searchObject,
    }),
    setListerIsLoadedAction: () => ({
        type: ListerActionTypes.SET_LISTER_ISLOADED,
    }),
};
